import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Kitchens', path: '/kitchens' },
    { name: 'Bathrooms', path: '/bathrooms' },
    { name: 'Closets', path: '/closets' },
  ];

  // Handle scroll to contact section if URL has hash
  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, [location]);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-primary/10 py-4 md:py-2.5 shadow-sm transition-all duration-300">
      <div className="container-custom flex justify-between items-center">
        <Link to="/" className="flex flex-col items-start group">
          <img 
            src="https://public.youware.com/image/3291ddf0-dd42-43f1-a5a0-d3e2cefcdde5/evw6qncyri.png" 
            alt="Luxe Cabinetry" 
            className="h-10 md:h-20 w-auto object-contain transition-transform duration-300 group-hover:scale-105" 
          />
        </Link>

        {/* Desktop Menu */}
        <div className="hidden md:flex space-x-8 items-center">
          {navLinks.map((link) => (
            <Link
              key={link.name}
              to={link.path}
              className={`text-primary text-xs md:text-sm uppercase tracking-[0.2em] font-semibold hover:text-accent transition-colors relative after:content-[''] after:absolute after:bottom-[-4px] after:left-0 after:w-0 after:h-0.5 after:bg-accent after:transition-all hover:after:w-full ${location.pathname === link.path ? 'text-accent after:w-full' : ''}`}
            >
              {link.name}
            </Link>
          ))}
          <a 
            href="/#contact"
            className="text-primary text-xs md:text-sm uppercase tracking-[0.2em] font-semibold hover:text-accent transition-colors relative after:content-[''] after:absolute after:bottom-[-4px] after:left-0 after:w-0 after:h-0.5 after:bg-accent after:transition-all hover:after:w-full"
          >
            Contact
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-primary hover:text-accent transition-colors p-1"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Menu Overlay */}
      <AnimatePresence>
        {isMobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden bg-white border-t border-primary/10 overflow-hidden shadow-xl"
          >
            <div className="flex flex-col p-6 space-y-4">
              {navLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.path}
                  className={`text-primary text-sm uppercase tracking-[0.2em] font-semibold hover:text-accent transition-colors py-2 border-b border-gray-50 ${location.pathname === link.path ? 'text-accent' : ''}`}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {link.name}
                </Link>
              ))}
              <a 
                href="/#contact"
                className="text-primary text-sm uppercase tracking-[0.2em] font-semibold hover:text-accent transition-colors py-2"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Contact
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;
